import React, { Component } from "react";
import PropTypes from "prop-types";
import { CSSTransitionGroup } from "react-transition-group";
import ConcernListItem from "./ConcernListItem.js";
import "./CompletedConcerns.css";

class CompletedConcerns extends Component {
  constructor() {
    super();

    this.state = {
      showCompleted: false,
    };
  }

  checkForCompletedConcerns = () => {
    for (const concern of this.props.concerns) {
      if (concern.status === "completed") {
        return true;
      }
    }
    return false;
  };

  renderCompletedButton = (showCompletedButton, hideCompletedButton) => {
    if (this.state.showCompleted) {
      return hideCompletedButton;
    } else {
      return showCompletedButton;
    }
  };

  toggleCompletedConcerns = () => {
    this.setState({
      showCompleted: !this.state.showCompleted,
    });

    window.analytics.track("Toggles Completed Concerns List");
  };

  render() {
    var showCompletedButton = (
      <div className="completed-button-container">
        <div
          className="completed-button show"
          onClick={this.toggleCompletedConcerns}
        >
          View Completed Concerns
        </div>
      </div>
    );

    var hideCompletedButton = (
      <div className="completed-button-container">
        <div
          className="completed-button hide"
          onClick={this.toggleCompletedConcerns}
        >
          All Completed Concerns -
        </div>
        <div className="horizontal-line" />
      </div>
    );

    var completedConcernsList = (
      <CSSTransitionGroup
        component="ul"
        transitionName="completed-concern-transition"
        transitionAppear={true}
        transitionAppearTimeout={300}
        transitionEnterTimeout={0}
        transitionLeaveTimeout={300}
      >
        {this.props.concerns.map(
          (concern, index) =>
            concern.status === "completed" ? (
              <ConcernListItem
                concern={concern}
                key={concern.id}
                index={index}
                updateConcernStatus={this.props.updateConcernStatus}
                members={this.props.members}
              />
            ) : null
        )}
      </CSSTransitionGroup>
    );

    return (
      <div className="completed-concerns-container">
        {this.checkForCompletedConcerns()
          ? this.renderCompletedButton(showCompletedButton, hideCompletedButton)
          : null}

        {this.checkForCompletedConcerns() && this.state.showCompleted
          ? completedConcernsList
          : null}
      </div>
    );
  }
}

CompletedConcerns.propTypes = {
  concern: PropTypes.shape({
    id: PropTypes.number.isRequired,
    concernText: PropTypes.string,
    reporter: PropTypes.string,
    assignee: PropTypes.string,
    plusOnes: PropTypes.number.isRequired,
    createdAt: PropTypes.number.isRequired,
    status: PropTypes.oneOf(["open", "queued", "completed"]),
    userId: PropTypes.string.isRequired,
  }),
  updateConcernStatus: PropTypes.func.isRequired,
  members: PropTypes.array.isRequired,
};

export default CompletedConcerns;



// WEBPACK FOOTER //
// ./src/components/CompletedConcerns.js